import { Company } from 'src/app/business/shared/company';

export class UserInfo {
    idUser:number;
    typeDoc:number;
    typePerson:number;
    docNumber:number;
    email:string;
    name:string;
    lastName:string;
    sourName:string;
    role:any[];
    company:Company;
    modules:any[];
    modulesWeCumplimineto:any[];
    typeUser:number;
}
